"use strict";

exports.__esModule = true;
exports.AddOnsClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _webCoreSdkV = require("@tajawal/web-core-sdk-v2");
var _constants = require("../constants");
var AddOnsClient = exports.AddOnsClient = {
  getAddOns: function getAddOns(payload, domain) {
    var requestId = 'GET_ADD_ONS';
    var tokenCacheKey = domain + "_APIToken";
    var cachedToken = _webCoreSdkV.$cookie.get(tokenCacheKey);
    return _http.$http.post(requestId, _constants.ENDPOINTS.GET_ADD_ONS, {
      data: payload,
      headers: {
        token: cachedToken
      }
    }).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  getAddOnsV3: function getAddOnsV3(payload, domain) {
    var requestId = 'GET_ADD_ONS_V3';
    var tokenCacheKey = domain + "_APIToken";
    var cachedToken = _webCoreSdkV.$cookie.get(tokenCacheKey);
    return _http.$http.post(requestId, _constants.ENDPOINTS.GET_ADD_ONS_V3, {
      data: payload,
      headers: {
        token: cachedToken
      }
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  }
};